import styled from 'styled-components';

export const TimelineViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`;
